import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CurrentSupervisionAction } from '../action/current-supervision.action';
import { CurrentSupervisionState } from '../reducer/current-supervision.reducer';
import { selectCurrentSupervisionFeature } from '../current-supervision-selector';
import { WkfSupervisionParams } from '../../../models/workflow/wkf-supervision-params';

@Injectable({
    providedIn: 'root'
})
export class CurrentSupervisionService {

    private currentSupervision$ = this.store.select(selectCurrentSupervisionFeature);
    private currentSupervision: CurrentSupervisionState;

    constructor(
        private currentSupervisionAction: CurrentSupervisionAction,
        private store: Store
    ) {
        this.currentSupervision$.subscribe(currentSupervision => this.currentSupervision = currentSupervision);
    }

    getCurrentWkfSupervisionParams(): WkfSupervisionParams {
        return this.currentSupervision?.datas?.currentWkfSupervisionParams;
    }

    setCurrentWkfSupervisionParams( wkfSupervisionParams: WkfSupervisionParams ) {
        this.currentSupervisionAction.loadCurrentWkfSupervisionParams(wkfSupervisionParams)
    }

    removeCurrentSupervisionWkfParams() {
        this.currentSupervisionAction.removeCurrentWkfSupervisionParams();
    }

    public getCurrentTaskSortKey(): string {
        const currentSupervisionState: CurrentSupervisionState = this.currentSupervision;
        if (!!currentSupervisionState && currentSupervisionState.datas.currentWkfSupervisionParams.configColumns.table) {
            return currentSupervisionState.datas.currentWkfSupervisionParams.configColumns.table?.defaultSort?.key;
        }
        return null;
    }

    public getCurrentTaskSortDirection(): string {
        const currentSupervisionState: CurrentSupervisionState = this.currentSupervision;
        if (!!currentSupervisionState && currentSupervisionState.datas.currentWkfSupervisionParams.configColumns.table) {
            return currentSupervisionState.datas.currentWkfSupervisionParams.configColumns.table?.defaultSort?.direction;
        }
        return null;
    }
}
